/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { PerimetroDto } from '@ideapa/common-dto';
import { DatiDelibera } from '@ideapa/common-utils';
import { map } from 'rxjs';
import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class PerimetroApiClient extends BaseCRUDApiClient<PerimetroDto> {
  baseUrl = this.config.apiEndpoint + '/perimetro';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  calcolaPerimetro() {
    this._pagedCache.clear();
    return this.http.post<PerimetroDto[]>(
      `${this.baseUrl}/calcola-perimetro`,
      {}
    );
  }

  downloadDelibera(body: { datiDelibera: DatiDelibera }) {
    return this.http
      .post(`${this.baseUrl}/download-delibera`, body, {
        responseType: 'arraybuffer',
      })
      .pipe(
        map((file: ArrayBuffer) => {
          return file;
        })
      );
  }

  confirmWarning(id: number) {
    this._pagedCache.clear();
    return this.http.get(`${this.baseUrl}/confirm-warnig/${id}`);
  }

  getSoggettiInclusi() {
    return this.http.get<PerimetroDto>(`${this.baseUrl}/soggetti-inclusi`);
  }
}
